// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-toast {
  border-radius: 4px;
  margin-bottom: 16px;
  pointer-events: none;
}
@media screen and (max-width: 1023px) {
  .bolt-toast {
    margin-bottom: 8px;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-toast {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-toast {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}

@keyframes slideInFromBottom {
  0% {
    opacity: 0;
    transform: translate(0px, 40px);
  }
  100% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
}
@keyframes slideOutToBottom {
  0% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
  100% {
    opacity: 0;
    transform: translate(0px, 40px);
  }
}
.bolt-toast-content {
  width: 356px;
}
@media screen and (max-width: 599px) {
  .bolt-toast-content {
    width: auto;
    flex-grow: 1;
    margin-left: 8px;
    margin-right: 8px;
  }
}
.bolt-toast-content {
  background-color: rgba( 51, 51, 51 ,  0.95 );
  background-color: rgba( var(--palette-neutral-80,51, 51, 51) ,  0.95 );
  border-radius: 4px;
  color: rgba( 255, 255, 255 ,  1 );
  color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  padding: 8px 20px;
  pointer-events: auto;
  animation: slideInFromBottom 0.5s;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-toast-content {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-toast-content {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
}
.bolt-toast-content.fade-out {
  animation: slideOutToBottom 0.5s forwards;
}
.bolt-toast-content.one-line .bolt-toast-message:not(:last-child) {
  margin-right: 20px;
}
.bolt-toast-content.one-line .bolt-toast-separator {
  width: 1px;
  margin-right: 8px;
}
.bolt-toast-content.one-line .bolt-toast-call-to-action-container {
  align-items: center;
}
.bolt-toast-content.multi-line .bolt-toast-message {
  margin-bottom: 8px;
}
.bolt-toast-content.multi-line .bolt-toast-separator {
  height: 1px;
  margin-bottom: 8px;
}
.bolt-toast-content.multi-line .bolt-toast-call-to-action-container {
  justify-content: flex-end;
}

.bolt-toast-message {
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  word-break: break-word;
}

.bolt-toast-separator {
  background-color: rgba( 255, 255, 255 ,  0.38 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  0.38 );
  justify-content: stretch;
}

.bolt-toast-call-to-action-container {
  display: inline-flex;
  margin-right: -12px;
}

.bolt-button.bolt-toast-call-to-action {
  color: rgba( 255, 255, 255 ,  1 );
  color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  white-space: nowrap;
}
.bolt-button.bolt-toast-call-to-action:hover {
  background-color: transparent;
}

/*# sourceMappingURL=Toast.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Toast/Toast.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Toast/Toast.css"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,mBC0TS;EDzTT,oBAAA;AEAJ;ADkWI;EDrWJ;IAMQ,kBC8SI;EC7SV;AACF;AD6XQ;ED3XA,sCAAA;EECN,gEAAgE;AD6X1D;AC3XR;EACE,sCAAsC;EACtC,gEAAgE;AFDlE;;AEIA;EACE;IACE,UAAU;IFAV,+BAAA;EEEF;EACA;IACE,UAAU;IACV,8BAA8B;EFClC;AECA;AACA;EACE;IACE,UAAU;IFEV,8BAAA;EEAF;EACA;IACE,UAAU;IACV,+BAA+B;EFGnC;AEDA;AACA;EDyTI,YAAA;ACvTJ;AACA;EACE;IFEM,WAAA;IACA,YAAA;IEAJ,gBAAgB;IAChB,iBAAiB;EFRrB;AEUA;AACA;EFCI,4CC8CI;ED7CJ,sEAAA;EAEA,kBAAA;EAEA,iCAAA;EEDF,0DAA0D;ED+UpD,iBAAA;ED3UA,oBCnCmB;EDoCnB,iCCxCmB;ACuC3B;AD8UQ;ED9UA,sCCnCmB;EDoCnB,sECxCmB;EC2CzB,0BAA0B;EFAxB,0DAAA;AEEJ;AACA;EFEQ,sCAAA;EACI,sEC4PC;EC5PX,0BAA0B;EFGpB,0DAAA;AEDR;AACA;EACE,yCAAyC;AFInC;AEFR;EACE,kBAAkB;AFQZ;AENR;EACE,UAAU;EFSJ,iBAAA;AEPR;AACA;EACE,mBAAmB;AFUb;AERR;EACE,kBAAkB;AACpB;AFYA;EACI,WAAA;EACA,kBAAA;AEVJ;AACA;EACE,yBAAyB;AAC3B;;AAEA;EFYI,gBAAA;EEVF,oBAAoB;EACpB,mBAAmB;EFYrB,sBAAA;AEVA;;AAEA;EACE,+CAA+C;EFYjD,wEAAA;EACI,wBCpBI;ACUR;;AFaI;EACI,oBAAA;EEVN,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0DAA0D;EAC1D,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
